import React, { useState, useEffect } from 'react';
import api from '../api';
import { format } from 'date-fns';

export const OutstandingBalances = () => {
  const [balances, setBalances] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('OWED');

  useEffect(() => { fetchBalances(); }, [status]);

  async function fetchBalances() {
    setLoading(true);
    try {
      const { data } = await api.get(`/admin/outstanding-balances${status ? `?status=${status}` : ''}`);
      setBalances(data.data.balances);
      setTotal(data.data.totalOwed);
    } catch (err) {
      setBalances([]); setTotal(0);
    } finally { setLoading(false); }
  }

  async function resolve(id, action) {
    let notes = '';
    if (action === 'paid') {
      notes = window.prompt('Payment notes (e.g. "Wire received 2026-07-26"):', '') || '';
    } else if (action === 'waive') {
      if (!window.confirm('Write off this balance? User will be unrestricted.')) return;
    } else if (action === 'review') {
      notes = window.prompt('Review notes:', '') || '';
    }
    try {
      const { data } = await api.post(`/admin/outstanding-balances/${id}/resolve`, { action, notes });
      alert(`Marked as ${data.data.status}${data.data.userRestrictionLifted ? ' — user unrestricted' : ''}`);
      fetchBalances();
    } catch (err) {
      alert(err.response?.data?.error?.message || err.message);
    }
  }

  const statusColors = { OWED: '#ef4444', IN_REVIEW: '#f59e0b', PAID: '#10b981', WRITTEN_OFF: '#64748b' };

  return (
    <div>
      <div className="card-header" style={{ padding: '0 0 24px 0', border: 'none' }}>
        <div>
          <h1 className="page-title" style={{ margin: 0 }}>Outstanding Balances</h1>
          <p style={{ color: 'var(--text-secondary)', margin: '4px 0 0' }}>
            Currently owed: <strong style={{ color: '#ef4444', fontSize: 18 }}>${Number(total).toFixed(2)}</strong>
          </p>
        </div>
        <select className="dropdown" value={status} onChange={e => setStatus(e.target.value)}>
          <option value="">All</option>
          <option value="OWED">Owed</option>
          <option value="IN_REVIEW">In review</option>
          <option value="PAID">Paid</option>
          <option value="WRITTEN_OFF">Written off</option>
        </select>
      </div>

      <div className="glass">
        <div className="table-container" style={{ border: 'none', borderRadius: '16px' }}>
          {loading ? <div className="loader-container"><div className="spinner"></div></div> : (
            <table>
              <thead>
                <tr>
                  <th>User</th>
                  <th>Amount</th>
                  <th>Reason</th>
                  <th>Circle</th>
                  <th>Age</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {balances.map(b => (
                  <tr key={b.id}>
                    <td>
                      <div style={{ fontWeight: 500 }}>{b.user?.firstName} {b.user?.lastName}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{b.user?.email}</div>
                      {b.user?.accountStatus === 'RESTRICTED' && (
                        <span className="badge" style={{ background: 'rgba(239,68,68,.15)', color: '#ef4444', fontSize: 10, marginTop: 4 }}>RESTRICTED</span>
                      )}
                    </td>
                    <td style={{ fontWeight: 600 }}>${Number(b.amount).toFixed(2)}</td>
                    <td>
                      <div style={{ fontFamily: 'monospace', fontSize: 12 }}>{b.reason}</div>
                      {b.reasonDetail && <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{b.reasonDetail}</div>}
                    </td>
                    <td>{b.circle?.name || <span style={{ color: 'var(--text-secondary)' }}>—</span>}</td>
                    <td style={{ color: 'var(--text-secondary)', fontSize: 12 }}>
                      {b.createdAt ? format(new Date(b.createdAt), 'MMM dd, yyyy') : '—'}
                    </td>
                    <td>
                      <span className="badge" style={{ background: statusColors[b.status] + '22', color: statusColors[b.status] }}>{b.status}</span>
                    </td>
                    <td>
                      {(b.status === 'OWED' || b.status === 'IN_REVIEW') && (
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="btn-success" onClick={() => resolve(b.id, 'paid')}>Mark Paid</button>
                          <button className="btn-secondary" onClick={() => resolve(b.id, 'review')}>Review</button>
                          <button className="btn-danger" onClick={() => resolve(b.id, 'waive')}>Waive</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
                {balances.length === 0 && (
                  <tr><td colSpan="7" style={{ textAlign: 'center', padding: 32, color: 'var(--text-secondary)' }}>No {status.toLowerCase().replace('_',' ')} balances.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};
